module.exports = __webpack_public_path__ + "static/dimaduchet_main-5898324619355857fc2df51d650772c8.png";